module.exports = __webpack_public_path__ + "img/kraken.d8db7504.webp";